import { Middleware } from '@reduxjs/toolkit';
import { RootState } from '../store';
import ringtoneSound from '../../assets/sounds/ring.mp3';
import disconnectSound from '../../assets/sounds/disconnected.mp3';

// Create audio instances
const ringingAudioRef = new Audio(ringtoneSound);
const disconnectAudioRef = new Audio(disconnectSound);

// Configure ringtone to loop
ringingAudioRef.loop = true;

export const audioMiddleware: Middleware<{}, RootState> = (store) => (next) => (action) => {
    const result = next(action);

    const state = store.getState();

    if (state.dialer.isRingingPlaying) {
        if (ringingAudioRef.paused) {
            ringingAudioRef.play().catch((error) => {
                console.error('Failed to play ringtone:', error);
            });
        }
    } else {
        if (!ringingAudioRef.paused) {
            ringingAudioRef.pause();
            ringingAudioRef.currentTime = 0;
        }
    }

    return result;
};

export { ringingAudioRef, disconnectAudioRef };